import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Assignment } from '../types';

export const exportToPDF = (data: Assignment[], fileName: string, qrCodeDataURL: string) => {
  const pdf = new jsPDF();

  // Add QR Code
  pdf.addImage(qrCodeDataURL, 'PNG', 10, 10, 50, 50);
  
  pdf.setFontSize(20);
  pdf.text('Assignments', 14, 75);

  autoTable(pdf, {
    head: [['Date', 'Barcode', 'Name', 'Phone', 'Assigned Locker']],
    body: data.map(row => [
      row.date ? row.date.toLocaleDateString('sr-RS') : '',
      row.barcode,
      row.recipientName,
      row.recipientPhone,
      row.assignedLocker || ''
    ]),
    startY: 80
  });

  pdf.save(`${fileName}.pdf`);
};